export default class Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    Object.assign(this, { uuid, ...attributes, options })
  }

  setIdentifier (uuid) {
    this.uuid = uuid
  }

  getIdentifier () {
    return this.uuid
  }

  validation () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/resources/Base.js